export default "__VITE_ASSET__BuzM9z6J__"